import { render, staticRenderFns } from "./CooperaList.vue?vue&type=template&id=69a65c2b&scoped=true&"
import script from "./CooperaList.vue?vue&type=script&lang=js&"
export * from "./CooperaList.vue?vue&type=script&lang=js&"
import style0 from "./CooperaList.vue?vue&type=style&index=0&id=69a65c2b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a65c2b",
  null
  
)

export default component.exports